/**
 * El backend entrega la fecha ISO ("2026-08-30T15:39:50.000000Z"). Se recorta
 * en seco, sin reinterpretar zonas horarias: los registros deben leerse con la
 * misma hora que guardo el servidor.
 */
export const formatFecha = (value) => {
  if (!value) return "-";
  return String(value).replace("T", " ").substring(0, 19);
};

export default formatFecha;
